import Swal from 'sweetalert2';
import { VideoService } from '../../services';
import { draftStore, preview, project, step, subtitles, prompt, menu } from '../../store';
import DraftService from '../../services/drafts';
import { MENU, STEP } from '../../types/common';
import '@/types/project';
export async function restoreDraft(draft, video) {
    menu.set(MENU.CLIPS);
    subtitles.set({ items: { raw: [], grouped: [] } });
    prompt.resetState();
    Swal.fire({
        title: 'Restoring Draft',
        didOpen: () => {
            Swal.showLoading();
        },
        allowOutsideClick: () => !Swal.isLoading(),
        allowEscapeKey: () => !Swal.isLoading(),
        allowEnterKey: () => !Swal.isLoading()
    });
    const videoService = new VideoService();
    const draftService = new DraftService();
    const videoResponse = await videoService.getVideo(video.id, true);
    //draftService.markIncomplete(draft.id);
    draft.project.video = videoResponse;
    draftStore.set({
        ...draft,
        currentDraft: draft.project,
        currentCloudDraftId: draft.id,
        currentStep: draft.currentStep,
        projectName: draft.projectName,
        metadata: draft.metadata,
        descriptions: draft.descriptions
    });
    project.set({
        ...draft.project,
        selectedSentences: draft.project.selectedSentences,
        transcription: videoResponse.transcription,
        video: videoResponse,
        compiledVideo: draft.project.compiledVideo ? draft.project.compiledVideo : null,
        isNew: draft.renderedVideos.length != 0 ? false : true,
        isUpdated: draft.renderedVideos.length != 0 ? false : true
    });
    preview.set({
        ...draft.metadata
    });
    if (draft.currentStep === STEP.ADMIN || draft.currentStep === null || draft.currentStep == STEP.CHOOSE_VIDEO) {
        step.update(STEP.CHOOSE_TEMPLATE);
    }
    else {
        step.update(draft.currentStep);
    }
    setTimeout(() => {
        Swal.close();
    }, 1000);
}
export async function deleteDraft(draft) {
    return new Promise(resolve => {
        Swal.fire({
            title: 'Are you sure you want to delete this clip?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete it'
        })
            .then(async (result) => {
            if (result.isConfirmed) {
                const ds = new DraftService();
                if (result.isConfirmed) {
                    ds.delete(draft.id)
                        .then(() => {
                        Swal.fire({
                            position: 'bottom-end',
                            icon: 'success',
                            title: 'Draft successfully deleted!',
                            showConfirmButton: false,
                            timer: 1500,
                            toast: true
                        });
                        resolve(true);
                    })
                        .catch(error => {
                        resolve(false);
                    });
                    return;
                }
                resolve(false);
            }
        })
            .catch(error => {
            resolve(false);
        });
    });
}
